module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/whatsapp-white-icon-0e0d9e896a6aac5009c8a6baa134a68f.png";